module.exports = __webpack_public_path__ + "files/4237b4468e4ea7c02112620d4009778a.svg";